import React from 'react';
import './EventSingle.css';

import { Car, PageSidebar, PageTitle } from '../../../components';

import { FaArrowRight } from 'react-icons/fa';
import { FaClock } from 'react-icons/fa6';

import { useLocation } from 'react-router-dom';



const EventSingle = () => { 

  // Get the event data from the router state
  const location = useLocation();  
  const eventSingle = location.state; 

  return (
    <>
      {/* Page Title */}
      <PageTitle title={'Event Single'} page={'Event Single'} />

      <section className='event-single page-single'>

        <div className='event-info page-info'>

          {/* Event Image */}
          <div className='image'>
            <img src={eventSingle.image} alt={eventSingle.title} />
          </div>

          <div className='content'>

            {/* Event Heading */}
            <h3 className='main-heading'>{eventSingle.title}</h3>

            {/* Event Description */}
            {eventSingle.paragraphs.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}

            {/* Event Highlights Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Event Highlights</h3>
              
              {/* List of Highlight Points */}
              <ul>
                {eventSingle.highlights.map((highlight, index) => (
                  <li key={index}>
                    <FaArrowRight className='icon' />
                    {highlight}
                  </li>
                ))}
              </ul>
            </div>

            {/* Event Schedule Section */}
            <div className='sub-section'>
              <h3 className='sub-heading'>Event Schedule</h3>
              
              {/* List of Schedule Sessions */}
              <ul>
                {eventSingle.schedule.map((session, index) => (
                  <li key={index}>
                    <FaClock className='icon' />
                    {session}
                  </li>
                ))}
              </ul>
            </div>

            {/* Featured Cars Section */}
            <div className='cars sub-section'>
              <h3 className='sub-heading'>Featured Cars:</h3>

                <div className="car-container grid">
                  {/* Render each car component */}
                  {eventSingle.featuredCars.map((car) => {
                    return(  
                      <Car key={car.id} car={car} /> 
                    )
                  }) 
                  }
                </div>

            </div> 

            {/* Event Venue Map */}
            <div className="event-map sub-section">
              <h3 className="sub-heading">Event Venue:</h3>
              <iframe
                src={eventSingle.venueMap}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                title="Event Venue Map"
              ></iframe> 
            </div>

          </div> 
        
        </div> 

        {/* Sidebar with Event Details */}
        <PageSidebar
          heading={'Event'}
          details={eventSingle.details}
          button={{ link: 'contact-us', title: 'Register Now' }}
        />

      </section>

    </> 
  );
}

export default EventSingle;